<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_club_member_search')"
                        :isFilter="false"
                        :isImportButton="true"
                        @import-button-click="importData"
                        :isNewButton="checkPermission('studentclubstudent_store')"
                        @new-button-click="createFormShow"
                        :otherButton="statusChangeObj"
                        @changeStatus="changeStatus"
                        :actionButtons="subButton">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_club_member_search')"
                              :isFilter="false"
                              :isImportButton="true"
                              @import-button-click="importData"
                              :isNewButton="checkPermission('studentclubstudent_store')"
                              @new-button-click="createFormShow"
                              :otherButton="statusChangeObj"
                              @changeStatus="changeStatus">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="checkPermission('studentclubstudent_excelexport')"
                              @exportExcel="downloadExcel"
            >
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox v-model="datatable.queryParams.filter.student_club_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('role')">
                            <parameter-selectbox code="student_club_roles" v-model="datatable.queryParams.filter.role"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                       <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="datatable.queryParams.filter.academic_year" />
                        </b-form-group>
                    </b-col>
                     <b-col sm="12" md="6">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="student_club_student_statuses"
                                v-model="datatable.queryParams.filter.status"
                            ></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="createFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubstudent_store')">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('studentclubstudent_update')">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toLocaleUpperCase('tr-TR') }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess=='update' && formId != 0"/>
                </template>
            </CommonModal>
             <CommonModal size="lg" ref="importModal">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('import_student_club_member_search') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <import-form @hide="closeImportModal" @onError="onError"></import-form>
                    </div>
                </template>
            </CommonModal>
            <CommonModal size="lg" ref="errorModal">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t('warning') }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <b-row v-for="error in importErrors" :key="error.student_number">
                            <b-col cols="4">{{error.student_number}}</b-col>
                            <b-col cols="8">{{ $t('api.'+error.message) }}</b-col>
                            <b-col cols="12"><hr></b-col>
                        </b-row>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

    //Page
    import CreateForm from './CreateForm'
    import UpdateForm from './UpdateForm'
    import ImportForm from "./importForm"

    //Service
    import StudentClubMemberSearch from '@/services/StudentClubMemberSearch';

    //Other
    import qs from 'qs';
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";

    export default {
        components: {
            StudentClubSelectbox,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            ParameterSelectbox,

            CreateForm,
            UpdateForm,
            ImportForm,
        },
        metaInfo() {
            return {
                title: this.$t('student_club_member_search')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('edit'),
                                    class: 'ri-edit-box-line',
                                    permission: 'studentclubstudent_update',
                                    callback: (row) => {
                                        this.formId = row.id;
                                        this.loadData();
                                    }
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission: 'studentclubstudent_delete',
                                    callback: (row) => {
                                        this.delete(row.id);
                                    }
                                }
                            ]
                        },
                        {
                            label: this.toUpperCase('student_number'),
                            field: 'student_number',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('name'),
                            field: "user.name",
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('surname'),
                            field: 'user.surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('club_name'),
                            field: 'student_club.name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: 'status',
                            hidden: false,
                            formatFn: (row) => {
                                if (row === 'active') {
                                    return this.$t('active');
                                } else if (row === 'passive') {
                                    return this.$t('passive');
                                } else if (row === 'waiting_payment') {
                                    return this.$t('waiting_payment');
                                } else {
                                    return '';
                                }
                            },
                        },
                        {
                            label: this.toUpperCase('role'),
                            field: this.getLocaleField('role_name'),
                            hidden: false,
                        },
                        {
                            label: this.toUpperCase('member_at'),
                            field: 'membership_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('gsm_no'),
                            field: 'user.mobile_tel',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('email'),
                            field: 'user.email',
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                importFile: null,
                statusChangeObj: {
                    show: () => {
                        return this.checkPermission('studentclubstudent_setpassivestudents')
                    },
                    emit: 'changeStatus',
                    title: this.$t('do_status_change'),
                    icon: 'ri-swap-2-line'
                },
                importErrors: [],
                subButton: [
                    {
                        text: `${this.$t('remove_waiting_payment_students')}`,
                        icon: "ri-user-unfollow-fill",
                        callback: async () => {
                            if(this.checkPermission('studentclubstudent_removewaitingpaymentstudents')){
                                this.$swal.fire({
                                    title: this.$t('warning'),
                                    text: this.$t('remove_waiting_payment_students_info'),
                                    showCancelButton: true,
                                    confirmButtonText: this.$t('yes'),
                                    cancelButtonText: this.$t('no'),
                                    icon: 'question'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        StudentClubMemberSearch.removeWaitingPaymentStudents().then(response => {
                                            this.$toast.success(this.$t('api.'+response.data.message))
                                        }).catch(e => {
                                            this.showErrors(e, null)
                                        })
                                    }
                                })
                            } else {
                                this.$toast.error(this.$t('unauthorized_operation'))
                            }
                        }
                    }
                ],

            }
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return StudentClubMemberSearch.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            loadData() {
                this.formProcess = 'update';
                StudentClubMemberSearch.get(this.formId)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.$refs.updateFormModal.$refs.commonModal.show();
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    }
                                });
            },
            delete(id) {
                this.deleteModal(() => {
                    StudentClubMemberSearch.del(id)
                                    .then((response) => {
                                        this.filter();
                                        this.$toast.success(this.$t('api.' + response.data.message));
                                    })
                                    .catch((error) => {
                                        this.$toast.error(this.$t('api.' + error.data.message));
                                    });
                });
            },
            async createFormSuccess() {
                this.$refs.createFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            async updateFormSuccess() {
                this.$refs.updateFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formId = 0
                this.formClear()
            },
            createFormShow() {
                this.formId = null
                this.form = {};
                this.formProcess = 'create'
                this.$refs.createFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            downloadExcel() {
                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                StudentClubMemberSearch.downloadAsExcel(config)
                                .then(res => this._downloadFile(res, this.$t('club_member_search') + '.xlsx'))
                                .catch(err => this.showErrors(err))
            },
            importData() {
				this.$refs.importModal.$refs.commonModal.show()
			},
            closeImportModal(){
                this.$refs.importModal.$refs.commonModal.hide()
            },

            changeStatus(){
                this.$swal
                    .fire({
                        title: this.$t('warning'),
                        text: this.$t('active_period_warning_msg'),
                        showCancelButton: true,
                        confirmButtonText: this.$t('yes'),
                        cancelButtonText: this.$t('no'),
                        icon: 'question'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            StudentClubMemberSearch.setPassiveStudents().then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message))
                            }).catch(e => {
                                this.showErrors(e, null)
                            })
                        }
                    })
            },

            onError(data){
                this.importErrors = data.data.data
                this.$refs.importModal.$refs.commonModal.hide()
                this.$refs.errorModal.$refs.commonModal.show()
            }
        }
    }
</script>
